import { render, staticRenderFns } from "./MemberForward.vue?vue&type=template&id=7fb04058&scoped=true&"
import script from "./MemberForward.vue?vue&type=script&lang=js&"
export * from "./MemberForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb04058",
  null
  
)

component.options.__file = "MemberForward.vue"
export default component.exports